import { QuickApiServiceBase, QuickConsoleLogger } from 'hooks/services';
import { appApiProvider } from './axiosApiProvider';

class VersionService extends QuickApiServiceBase {
	constructor() {
		super(
			new QuickConsoleLogger('VersionService'),
			appApiProvider,
			'version',
			'Version'
		);
	}

	public async sendVersion(version: string): Promise<{
		success: boolean;
	}> {
		return await this.postOrThrow({ version }, { url: '/approve' });
	}
}

export const versionService = new VersionService();
